const scrollToTarget = (target, options) => {
  let scrollPostion = target.getBoundingClientRect().top + window.scrollY;
  window.scrollTo({ top: scrollPostion, behavior: "smooth" });
};
const stopScroll = () => {
  const { body } = document;
  body.style.overflow = "hidden";
  body.style.height = "var(--app-height)";
};
const resumeScroll = () => {
  const { body } = document;
  body.style.overflow = "";
  body.style.height = "";
};
export {
  scrollToTarget as a,
  resumeScroll as r,
  stopScroll as s
};
